import React, { useState } from 'react';
import GenericModal from '@src/components/shared/generic-modal/generic-modal';
import {EventType} from '@src/dtos/analytics.dto';
import {observer} from 'mobx-react-lite';
import {useStores} from '@src/components/store';
import mlRecommendationService from '@src/services/ml-recommendation.service';
import usePromiseFeedback from '@src/components/shared/promise-feedback/usePromiseFeedback';

export interface StopPolicyRecommendationsModalProps {
    open: boolean;
    onClose: () => void;
}

const StopPolicyRecommendationsModal: React.FC<StopPolicyRecommendationsModalProps> = observer(({
    open,
    onClose,
}) => {
    const { fwVersionStore, customerStore } = useStores();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const [isStopping, setIsStopping] = useState(false);

    const body = (
        <div className="stop-policy-recommendations-modal-content">
            <div className="stop-policy-recommendations-modal-subtitle">
                Are you sure you want to stop receiving policy recommendations? this will stop recommendations to all connections.
            </div>
        </div>
    );

    const handleStop = () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, { button: 'stopRecommendations', location: 'policyUpdateRecommendation' });
        setIsStopping(true);
        promiseFeedbackFactory({
            promise: mlRecommendationService.setMlState(
                customerStore.customerId,
                false
            ),
            notifObj: { show: true, notificationMsg: 'Policy recommendations disabled' },
            successCallback: () => {
                setIsStopping(false);
                onClose();
            },
            errorCallback: () => {
                setIsStopping(false);
                onClose();
            }
        });
    };

    const actionButtons = [
        {
            text: 'Keep recommendations',
            onClick: onClose,
            className: 'secondary-btn',
        },
        {
            text: 'Yes, stop recommendations',
            onClick: handleStop,
            className: `primary-btn ${isStopping ? 'loading' : ''}`,
            disabled: isStopping
        },
    ];

    return (
        <>
            <GenericModal
                title="Stop policy recommendations"
                body={body}
                actionButtons={actionButtons}
                open={open}
                onCancel={onClose}
                wrapClassName="stop-policy-recommendations-modal"
                width={624}
                closable={true}
            />
            {promiseContextHolder}
        </>
    );
});

export default StopPolicyRecommendationsModal;
